<script setup lang="ts">
  interface Props {
    description?: string;
  }
  defineProps<Props>();

  // もっと見る|閉じる どちらを表示するか
  const readMore = ref(true);
  // もっと見るheight監視対象
  const readMoreElement = ref<HTMLDivElement | undefined>(undefined);
  // もっと見るボタンクリックイベント
  const clickReadMore = () => {
    readMore.value = !readMore.value;
  };
  // もっと見るを表示するか
  const showReadMore = computed<boolean>(() => {
    if (readMoreElement.value?.scrollHeight && readMoreElement.value?.scrollHeight > 100) {
      return true;
    }
    return false;
  });
  // 詳細エリアのheight
  const descriptionAreaHeight = computed<number | "auto">(() => {
    if (showReadMore.value && readMore.value) {
      return 66;
    }
    return "auto";
  });
</script>

<template>
  <v-sheet class="px-1 pt-0 pb-1 rounded" color="monochrome-04">
    <v-sheet class="text-content-detail-m overflow-y-hidden mb-2" color="transparent" :height="descriptionAreaHeight">
      <div ref="readMoreElement" class="overflow-y-hidden" color="monochrome-04" style="white-space: break-spaces">
        <AtomsAutoLink :text="description ?? ''" />
      </div>
    </v-sheet>
    <v-sheet class="ma-0 rounded overflow-y-hidden" color="transparent">
      <v-btn
        v-if="showReadMore"
        class="text-content-detail-readmore px-0 cursor-pointer"
        color="transparent"
        :ripple="false"
        variant="text"
        @click="clickReadMore"
      >
        <span v-if="readMore" class="text-main-01 font-weight-bold">
          <v-icon icon="$mdiChevronDown" size="large" />
          もっと見る
        </span>
        <span v-else class="text-main-01 font-weight-bold">
          <v-icon icon="$mdiChevronUp" size="large" />
          閉じる
        </span>
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
